import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import SettingsGroup from 'components/Shared/SettingsGroup';
import { FlexRow } from 'components/Shared/Scaffolding';
import { Card } from 'components/Shared/Cards';
import { GLYPHS } from 'components/Shared/Icon';
import { TYPOGRAPHY } from 'theme';

const propTypes = {
    size: PropTypes.object.isRequired,
    zoom: PropTypes.number.isRequired,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    onCardClick: PropTypes.func,
};

const defaultProps = {
    onCardClick: null,
};

const mapStateToProps = (state) => ({
    size: state.map.size,
    zoom: state.map.location.zoom,
    lat: state.map.location.center.lat,
    lng: state.map.location.center.lng,
});

const Label = styled.strong`
    flex: 0 0 auto;
`;

const Value = styled.span`
    flex: 1 1 auto;
`;

const Preview = ({ size, zoom, lat, lng, onCardClick, className, labelClassName, contentClassName }) => {
    const { width, widthUnit, height, heightUnit } = size;
    return (
        <SettingsGroup
            name="Size & Location"
            description="Choose a size, default center location, and zoom level for your map"
            className={className}
            labelClassName={labelClassName}
            contentClassName={contentClassName}
        >
            <Card
                onClick={onCardClick}
                leftGlyph={GLYPHS.CENTER}
                leftGlyphColor={TYPOGRAPHY.COLOR_REDUCED}
                rightGlyph={GLYPHS.EDIT}
            >
                <FlexRow inline spacing="4px">
                    <Label>Size:</Label>
                    <Value>
                        {width}
                        {widthUnit} × {height}
                        {heightUnit}
                    </Value>
                </FlexRow>
                <FlexRow inline spacing="4px">
                    <Label>Center:</Label>
                    <Value>
                        {lat}, {lng}
                    </Value>
                </FlexRow>
                <FlexRow inline spacing="4px">
                    <Label>Zoom Level:</Label>
                    <Value>{zoom}</Value>
                </FlexRow>
            </Card>
        </SettingsGroup>
    );
};

Preview.propTypes = propTypes;
Preview.defaultProps = defaultProps;

export default connect(mapStateToProps)(Preview);
